import React, { Component } from 'react'

class PayForKnowledge extends Component {
    render() {
        return (
            <div style={{ width: '100%', height: '100vh' }}>
                <iframe
                    title="liantuo-shence"
                    src={`${process.env.PUBLIC_URL}/liantuoshence.html`}
                    style={{ width: '100%', height: '100%', border: 'none' }}
                />
            </div>
        )
    }
}

export default PayForKnowledge
